export enum AutomaticAdviceEvents {
  automaticAdviceCropFieldDone = 'Agrifirm.ArableAdvice.AutomaticAdviceCropFieldDone',
  automaticAdviceDone = 'Agrifirm.ArableAdvice.AutomaticAdviceDone'
}

export interface AutomaticAdviceCropFieldDoneEvent {
  CustomerId: number;
  CropFieldId: number;
  Year: number;
}

export interface AutomaticAdviceDoneEvent {
  customerId: number;
  year: number;
}
